interface TableHeaderProps {
  headers: string[];
  hasActions?: boolean;
  actionsColumnTitle?: string;
}

const TableHeader = ({
  headers,
  hasActions,
  actionsColumnTitle = "Ações",
}: TableHeaderProps) => (
  <thead className="bg-neutral-200">
    <tr>
      {headers.map((header, index) => (
        <th
          key={index}
          className="px-6 py-3 text-left text-xs font-bold uppercase tracking-wider text-neutral-500"
        >
          {header}
        </th>
      ))}
      {hasActions && (
        <th className="px-6 py-3 text-left text-xs font-bold uppercase tracking-wider text-neutral-500">
          {actionsColumnTitle}
        </th>
      )}
    </tr>
  </thead>
);

export default TableHeader;
